import React from 'react'

export default function Equalizer({ className }) {
  return (
    <svg viewBox="0 0 20 17" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M14 17v-2h6v2h-6zm0-5h6v2h-6v-2zm0-3h6v2h-6V9zm0-3h6v2h-6V6zm-7 9h6v2H7v-2zm0-3h6v2H7v-2zm0-3h6v2H7V9zm0-3h6v2H7V6zm0-3h6v2H7V3zm0-3h6v2H7V0zM0 15h6v2H0v-2zm0-3h6v2H0v-2z"
      />
    </svg>
  )
}
